(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystic-age-check"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mystic-age-check')) {
  customElements.define('mystic-age-check', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.key = 'mystic-uri-age-v1-' + this.dataset.age;
      this.editor = this.dataset.editor === 'true';
      if (this.dataset.enabled !== 'true') return;
      if (this.editor) {
        this.dialog.setAttribute('open','');
        this.querySelector('[data-editor-note]').hidden=false;
      } else if (!this.confirmed()) {
        this.dialog.showModal();
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow='hidden';
        this.locked=true;
      }
      this.dialog.addEventListener('cancel',event=>event.preventDefault(),opts);
      this.querySelector('[data-yes]').addEventListener('click',()=>{
        if (this.editor || this.leaving) return;
        this.leaving = true;
        this.querySelectorAll('button').forEach(button => { button.disabled = true; });
        const days = Number(this.dataset.days);
        try {
          const storage = days === 0 ? sessionStorage : localStorage;
          storage.setItem(this.key,JSON.stringify({expires:Date.now() + (days === 0 ? 86400000 : days*86400000)}));
        } catch (_) { /* Storage blocked: allow current page; ask again on next page. */ }
        const finish = () => {
          this.dialog.close(); this.unlock();
          const target = document.querySelector('main a[href], main button:not([disabled]), #MainContent, main');
          if (target) {
            const needsTabindex = !target.hasAttribute('tabindex') && !target.matches('a,button');
            if (needsTabindex) target.setAttribute('tabindex','-1');
            target.focus({preventScroll:true});
            if (needsTabindex) target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});
          }
        };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
        } else {
          this.dialog.classList.add('mu-age--leaving');
          this.exitTimer = setTimeout(finish, 780);
        }
      },opts);
      this.querySelector('[data-no]').addEventListener('click',()=>{
        this.querySelector('[data-denied]').hidden=false;
        this.querySelector('[data-yes]').hidden=true;
        this.querySelector('[data-no]').disabled=true;
      },opts);
    }
    confirmed() {
      try {
        const storage=Number(this.dataset.days)===0?sessionStorage:localStorage;
        const value=JSON.parse(storage.getItem(this.key)||'null');
        return value && Number.isFinite(value.expires) && value.expires>Date.now();
      } catch (_) {return false;}
    }
    unlock(){if(this.locked){document.documentElement.style.overflow=this.oldOverflow;this.locked=false;}}
    disconnectedCallback(){clearTimeout(this.exitTimer);this.dialog?.close();this.unlock();this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystic-book"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mystic-book')) {
  customElements.define('mystic-book', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      const list = this.querySelector('[data-tabs]');
      if (list && this.tabs.length) {
        list.hidden = false;
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index), opts);
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
          }, opts);
        });
        this.select(0);
      }
      const stage = this.querySelector('.mu-book__stage');
      const cover = this.querySelector('.mu-book__cover');
      const allowed = () => this.dataset.tilt === 'true' && matchMedia('(hover: hover) and (pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      stage.addEventListener('pointermove', (event) => {
        if (!allowed()) { cover.style.transform = ''; return; }
        const rect = stage.getBoundingClientRect();
        const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
        cover.style.transform = `rotateY(${-24 + (x - .5) * 16}deg) rotateX(${6 - (y - .5) * 10}deg)`;
      }, opts);
      stage.addEventListener('pointerleave', () => { cover.style.transform = ''; }, opts);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.select(index);
      }, opts);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index; });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystic-clouds"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mystic-clouds')) {
    customElements.define('mystic-clouds', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true') return;
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = null;
        this.visible = false;
        this.update = () => {
          if (!this.visible || this.frame !== null || this.media.matches) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const rect = this.getBoundingClientRect();
            const start = window.innerHeight * .85;
            const end = -rect.height * .35;
            const progress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
            this.style.setProperty('--mc-progress', progress.toFixed(4));
          });
        };
        this.motionChanged = () => {
          if (this.media.matches) {
            if (this.frame !== null) cancelAnimationFrame(this.frame);
            this.frame = null;
            this.style.removeProperty('--mc-progress');
          } else this.update();
        };
        window.addEventListener('scroll', this.update, {passive:true});
        window.addEventListener('resize', this.update, {passive:true});
        this.media.addEventListener('change', this.motionChanged);
        if (window.IntersectionObserver) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.update();
          }, {rootMargin:'150px'});
          this.observer.observe(this);
        } else {this.visible = true; this.update();}
      }
      disconnectedCallback() {
        if (!this.update) return;
        window.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
        this.media.removeEventListener('change', this.motionChanged);
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystic-collections-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mystic-collection-products')) {
    customElements.define('mystic-collection-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.sparkles !== 'true' || !window.IntersectionObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(max-width: 749px)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
              entry.target.classList.add('mcp-arrived');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.25 });
        this.querySelectorAll('.mcp-card').forEach(card => this.observer.observe(card));
      }
      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystic-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mystic-products')) {
    customElements.define('mystic-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.sparkles !== 'true' || !window.IntersectionObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(max-width: 749px)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.65) {
              entry.target.classList.add('mp-arrived');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.65 });
        this.querySelectorAll('.mp-card').forEach(card => this.observer.observe(card));
      }
      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystic-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mystic-testimonials')) {
    customElements.define('mystic-testimonials', class extends HTMLElement {
      connectedCallback() {
        const group = this.querySelector('.mu-reviews__group');
        this.button = this.querySelector('.mu-reviews__toggle');
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.sync = () => {
          if (this.clone) {this.clone.remove(); this.clone = null;}
          this.removeAttribute('data-loop');
          if (group.children.length > 1 && !this.media.matches) {
            this.clone = group.cloneNode(true);
            this.clone.setAttribute('aria-hidden', 'true');
            this.clone.setAttribute('inert', '');
            this.clone.querySelectorAll('[data-shopify-editor-block]').forEach(card => card.removeAttribute('data-shopify-editor-block'));
            this.querySelector('.mu-reviews__track').append(this.clone);
            this.dataset.loop = 'true';
          }
        };
        this.toggle = () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.textContent = paused ? 'Resume scrolling' : 'Pause scrolling';
        };
        this.selectBlock = event => {if (this.contains(event.target)) this.dataset.editorPaused = this.dataset.paused = 'true';};
        this.deselectBlock = () => {if (this.dataset.editorPaused === 'true') {delete this.dataset.editorPaused; this.dataset.paused = this.button?.getAttribute('aria-pressed') || 'false';}};
        if (this.button) this.button.addEventListener('click', this.toggle);
        this.media.addEventListener('change', this.sync);
        document.addEventListener('shopify:block:select', this.selectBlock);
        document.addEventListener('shopify:block:deselect', this.deselectBlock);
        this.sync();
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.toggle);
        if (this.media) this.media.removeEventListener('change', this.sync);
        document.removeEventListener('shopify:block:select', this.selectBlock);
        document.removeEventListener('shopify:block:deselect', this.deselectBlock);
        if (this.clone) this.clone.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
